<template>
  <div id="app">
    <RouterViewPage></RouterViewPage>
    <AnnounceBox v-show="displayAlert" @close-alert="hideAlert"></AnnounceBox>
    <AlertWindow />
    <CookieAgree></CookieAgree>
    <Loading v-show="isLoading"></Loading>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';
import { useStore } from 'vuex';
import AnnounceBox from '@/components/Announce.vue';
import CookieAgree from '@/components/Cookie.vue';
import RouterViewPage from '@/pages/RouterView.vue';
import Loading from '@/components/Loading.vue';
import AlertWindow from '@/components/AlertWindow.vue';

const displayAlert = ref(false);

const store = useStore();

const isMaintenance = computed(() => store.state.isMaintenance);
const isLoading = computed(() => isMaintenance.value === null);

const hideAlert = () => {
  document.body.style.overflow = '';
  displayAlert.value = false;
};

onMounted(() => {
  if (!displayAlert.value) {
    document.body.style.overflow = '';
  }
});
</script>
